import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import Icons from '../../../components/icons';
import { uniqBy } from 'lodash';

export const getPaymentSchemeOptionColumns = (
  onEdit: (row: any) => void,
  onDelete: (row: any) => void
): GridColDef[] => [
  {
    field: 'schemeName',
    headerName: 'Scheme Name',
    flex: 1
  },
  {
    field: 'noOfInstallment',
    headerName: 'No. of Installments',
    flex: 1,
    renderCell: (params) => (
      <Typography>
        {uniqBy(params.row.installments, 'feePeriod').length}
      </Typography>
    )
  },
  {
    field: 'action',
    headerName: 'Actions',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => (
      <Box>
        <Tooltip title='Edit'>
          <IconButton onClick={() => onEdit(params.row)}>
            <Icons.EditBlackOutlined />
          </IconButton>
        </Tooltip>
        <Tooltip title='Edit'>
          <IconButton onClick={() => onDelete(params.row)}>
            <Icons.Delete />
          </IconButton>
        </Tooltip>
      </Box>
    )
  }
];
